export default __webpack_public_path__ + "static/media/2 Success Analysis.05a07b6d.png";